import React, { useState, useEffect } from 'react';

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => prev === 0 ? 1 : prev === 1 ? 2 : 0);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="hero" id="hero">
        <div className="hero-slider">
          <div className={`slide ${currentSlide === 0 ? 'active' : ''}`}>
            <div className="container">
              <div className="hero-content">
                <h2>INTERNET DE ALTA<br />VELOCIDADE</h2>
                <p>Conecte-se ao futuro com a UNET! Oferecemos os melhores planos de internet com tecnologia de ponta. Escolha entre 400 Mega, 600 Mega ou 1 Giga de velocidade.</p>
                <a href="#planos" className="btn-primary">CONHECER PLANOS</a>
              </div>
            </div>
          </div>
          <div className={`slide ${currentSlide === 1 ? 'active' : ''}`}>
            <div className="container">
              <div className="hero-content">
                <h2>FIBRA ÓPTICA<br />DE QUALIDADE</h2>
                <p>Experimente a diferença da fibra óptica da UNET! Internet estável, sem quedas e com suporte especializado. Instalação rápida e sem complicações. Venha fazer parte da nossa rede!</p>
                <a href="#planos" className="btn-primary">ASSINAR AGORA</a>
              </div>
            </div>
          </div>
          <div className={`slide ${currentSlide === 2 ? 'active' : ''}`}>
            <div className="container">
              <div className="hero-content">
                <h2>POR QUE ESCOLHER<br />A UNET?</h2>
                <p>Fibra Óptica de alta velocidade • Monitoramento Intensivo • Instalação Rápida • Internet sem limites • Suporte especializado • Tecnologia de ponta</p>
                <a href="#diferenciais" className="btn-primary">CONHECER DIFERENCIAIS</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <section className="plans" id="planos">
        <div className="container">
          <div className="plans-grid">
            <div className="plan-card">
              <div className="plan-header">
                <h3>COMFORT</h3>
              </div>
              <div className="plan-body">
                <div className="plan-speed">400 MB</div>
                <div className="plan-price">
                  <span className="currency">R$</span>
                  <span className="amount">78,00</span>
                  <span className="period">/mês</span>
                </div>
                <a href="/cadastro?plano=COMFORT" className="btn-assinar">Assine já</a>
              </div>
            </div>

            <div className="plan-card">
              <div className="plan-header">
                <h3>PREMIUM</h3>
              </div>
              <div className="plan-body">
                <div className="plan-speed">600 MB</div>
                <div className="plan-price">
                  <span className="currency">R$</span>
                  <span className="amount">88,00</span>
                  <span className="period">/mês</span>
                </div>
                <a href="/cadastro?plano=PREMIUM" className="btn-assinar">Assine já</a>
              </div>
            </div>

            <div className="plan-card featured">
              <div className="plan-header">
                <h3>HARDCORE GAMER</h3>
              </div>
              <div className="plan-body">
                <div className="plan-speed">1 GB</div>
                <div className="plan-price">
                  <span className="currency">R$</span>
                  <span className="amount">128,00</span>
                  <span className="period">/mês</span>
                </div>
                <div className="plan-features">
                  <div className="feature">WIFI 6</div>
                  <div className="feature">IP PÚBLICO DEDICADO</div>
                </div>
                <a href="/cadastro?plano=HARDCORE GAMER" className="btn-assinar">Assine já</a>
              </div>
            </div>
          </div>

          <div className="plans-disclaimer">
            <p className="disclaimer-text">*VERIFICAR DISPONIBILIDADE DO LOCAL</p>
            <p className="offer-valid">OFERTAS VÁLIDAS ATÉ 31/03/2026</p>
            <p className="fidelity-info">TODOS OS PLANOS COM FIDELIZAÇÃO DE 12 MESES</p>
          </div>
        </div>
      </section>

      {/* Why Choose UNET Section */}
      <section className="why-choose" id="diferenciais">
        <div className="container">
          <div className="section-header">
            <h2>POR QUE ESCOLHER A UNET?</h2>
            <p>Conectamos você ao que há de melhor em internet</p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-wifi"></i>
              </div>
              <h3>Fibra Óptica</h3>
              <p>Internet de alta velocidade com tecnologia de ponta e estabilidade garantida</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-headset"></i>
              </div>
              <h3>Monitoramento Intensivo</h3>
              <p>Monitoramento intensivo, para a prevenção de quedas massivas sem a necessidade de abertura de chamado.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>Instalação Rápida</h3>
              <p>Instalação rápida após a contratação, sem complicações</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Sem Limite</h3>
              <p>Navegue sem limites, sem cobrança de franquia ou restrições de uso</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home; 